type StorageMeterProps = {
  used: number;
  max: number;
  label?: string;
  variant?: "block" | "inline";
};

export default function StorageMeter({
  used,
  max,
  label,
  variant = "block",
}: StorageMeterProps) {
  const ratio = max > 0 ? Math.min((used / max) * 100, 100) : 0;

  if (variant === "inline") {
    return (
      <div className="flex items-center gap-2">
        <i className="ri-hard-drive-2-line text-gray-400 text-sm"></i>
        <div className="flex flex-col gap-0.5">
          <span className="text-xs text-gray-600 leading-none">
            {used.toFixed(1)}{" "}
            <span className="text-gray-400">/ {max} MB</span>
          </span>
          <div className="w-20 sm:w-28 bg-gray-200 rounded-full h-1">
            <div
              className="bg-indigo-400 h-1 rounded-full transition-all"
              style={{ width: `${ratio}%` }}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-xs text-gray-500">{label}</span>
        <span className="text-xs font-medium text-gray-700">
          {used.toFixed(1)} / {max} MB
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-1.5">
        <div
          className="bg-indigo-500 h-1.5 rounded-full transition-all"
          style={{ width: `${ratio}%` }}
        />
      </div>
    </div>
  );
}
